import { render, staticRenderFns } from "./ehc-card.vue?vue&type=template&id=ab2cf7da"
import script from "./ehc-card.vue?vue&type=script&lang=js"
export * from "./ehc-card.vue?vue&type=script&lang=js"
import style0 from "./ehc-card.vue?vue&type=style&index=0&id=ab2cf7da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports